import React from 'react';
import { SearchOutlined } from '@mui/icons-material';
import { Button, Dialog, FormControl, Grid, IconButton, InputLabel, MenuItem, Paper, Select, Slide, TextField } from '@mui/material';
import useDebounce from 'hooks/useDebounce';
import MainCard from 'ui-component/cards/MainCard';
import { deleteFeedback, getFeedback, updateFeedback } from 'utils/APIs';
import Table from 'views/utilities/Table';
import { toast } from 'react-toastify';
import Confirmation from 'views/utilities/Confirmation';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import SendFeedback from './SendFeedback';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ViewFeedback = () => {
    const { t } = useTranslation();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(40);
    const [name, setName] = React.useState('');
    const [loading, setloading] = React.useState(true);
    const [feedbackData, setFeedbackData] = React.useState();
    const debouncedSearchTerm = useDebounce(name, 500);
    const [feedbackCount, setFeedbackCount] = React.useState(0);
    const [selectedRow, setselectedRow] = React.useState(null);
    const [status, setStatus] = React.useState('');
    const [openFeedbackModal, setOpenFeedbackModal] = React.useState(false);
    const [showFeedback, setShowFeedback] = React.useState(false)
    const [feedbackDetail, setFeedbackDetail] = React.useState([])
    const [feedbackId, setFeedbackId] = React.useState('')
    const theme = useTheme();

    const handleChangeStatus = (event) => {
        setStatus(event.target.value);
    };
    const onClickView = (data) => {
        setFeedbackDetail(data)
        setShowFeedback(!showFeedback)
    }
    const getFeedbackList = async () => {
        setloading(true);
        const data = await getFeedback(rowsPerPage, page + 1, status);
        setFeedbackData(data?.data?.results);
        setFeedbackCount(data?.data?.totalResults);
        setloading(false);
    };
    React.useEffect(() => {
        getFeedbackList();
    }, [rowsPerPage, page + 1, debouncedSearchTerm]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const columns = [
        {
            id: 'feedback',
            label: t('Feedback'),
            minWidth: 170
        },
        {
            id: 'status',
            label: t('Status'),
            minWidth: 170
        },
        {
            id: 'action',
            label: t('Action'),
            minWidth: 170,
            align: 'center'
        }
    ];

    const onClickDelete = (selectedUser) => {
        setselectedRow(selectedUser);
    };
  
    const handleConfirm = async () => {
        try {
            await deleteFeedback(selectedRow?.id);
            toast.success('Feedback deleted successfully');
            getFeedbackList();
        } catch (error) {
            toast.error(error.message);
            getFeedbackList();
        } finally {
            setselectedRow(null);
        }
    };

    const onFeedbackModalHandler = (id) =>{
        setFeedbackId(id)
        setOpenFeedbackModal(!openFeedbackModal)
    }

    const onChangeFeedbackStatus = async (id,value) => {
        try {
            await updateFeedback(JSON.stringify({ status : value}), id);
            toast.success('Status Update Sucessfully');
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message);
        } finally {
            getFeedbackList()
        }
    }

    return (
        <div>
            <Confirmation
                open={selectedRow !== null}
                handleClose={() => setselectedRow(null)}
                handleConfirm={handleConfirm}
                title="Delete Confirmation"
                itemName={selectedRow?.feedback}
            />
           
            <MainCard title={t('View Feedbacks')}>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ alignItems: 'center' }}>
                        <Grid item xs={7}>
                            <TextField
                                fullWidth
                                sx={{ ...theme.typography.customInput }}
                                id="standard-bare"
                                placeholder={t('Search')}
                                variant="outlined"
                                onChange={(e) => setName(e?.target?.value)}
                                value={name}
                                InputProps={{
                                    endAdornment: (
                                        <IconButton>
                                            <SearchOutlined />
                                        </IconButton>
                                    )
                                }}
                            />
                        </Grid>
                        <Grid item xs={5}>
                        <FormControl sx={{ m: 1, minWidth: 120 }} size="medium">
                            <InputLabel id="demo-select-medium">{t('Status')}</InputLabel>
                            <Select
                                labelId="demo-select-medium"
                                id="demo-select-medium"
                                value={status}
                                fullWidth
                                label={t("Status")}
                                onChange={handleChangeStatus}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                <MenuItem value='active'>{t('Active')}</MenuItem>
                                <MenuItem value='deactive'>{t('Deactive')}</MenuItem>
                                <MenuItem value='inprocess'>{t('InProcess')}</MenuItem>
                                <MenuItem value='resolved'>{t('Resolved')}</MenuItem>
                                <MenuItem value='paused'>{t('Paused')}</MenuItem>
                            </Select>
                        </FormControl>
                        </Grid>
                    </Grid>
                    <div className="feedback-table">
                        <Table
                            columns={columns}
                            loading={loading}
                            data={feedbackData}
                            totalCount={feedbackCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            onClickDelete={onClickDelete}
                            onClickView={onClickView}
                            type="country"
                            isView
                            addFeedback
                            onFeedbackModalHandler={onFeedbackModalHandler}  
                            onChangeFeedbackStatus={onChangeFeedbackStatus}                     
                            noEdit
                        />
                    </div>
                </Paper>
            </MainCard>
          
            <SendFeedback open={openFeedbackModal} setopenForm={setOpenFeedbackModal} feedbackId={feedbackId} />
            <Dialog
                open={showFeedback}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="sm"
            >
                <Button
                    variant="secondary"
                    onClick={() => setShowFeedback(!showFeedback)}
                    className="text-center"
                >
                    {t("Close X")}
                </Button>
                <MainCard title="View Feedback" contentClass="card-content">
                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={12}>
                                <InputLabel id="demo-select-medium">{t('Feedback Description')}</InputLabel>
                                <div>{feedbackDetail?.feedback}</div>
                            </Grid>
                        </Grid>
                </MainCard>
            </Dialog>
        </div>
    );
};

export default ViewFeedback;
